import { Heading } from "@tiptap/extension-heading";

const HeadingExtended = Heading.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      stylePreferences: {},
    }
  },

  addAttributes() {
    return {
      ...this.parent?.(),
      "data-anchor": {
        default: null,
      },
    };
  },

  renderHTML({ node, HTMLAttributes }) {
    const anchor = node.textContent;
    const level = node.attrs.level;
    const tagName = `h${level}`;

    HTMLAttributes["data-anchor"] = anchor;
    HTMLAttributes["data-view-scroll-target"] = "reportSection";

    const stylePrefs = this.options.stylePreferences;
    let styleString = stylePrefs[tagName] || '';

    if (node.attrs.textAlign && node.attrs.textAlign !== 'left') {
      const textAlignStyle = `text-align: ${node.attrs.textAlign}`;
      styleString = styleString ? `${styleString}; ${textAlignStyle}` : textAlignStyle;
    }

    if (styleString) {
      HTMLAttributes.style = styleString;
    }

    return this.parent?.({ node, HTMLAttributes });
  },
})

export default HeadingExtended;
